import { Card } from "@/src/components/cards";
import { openDeleteDialog } from "@/src/components/dialogs";
import { SampleSlice } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { openAnapathSampleSliceForm } from "./sampleSliceForm";

function SliceCard({
  slice,
  onChange,
}: {
  slice: SampleSlice;
  onChange: (sampleSlice: SampleSlice) => void;
}) {
  return (
    <Card
      key={slice.id}
      color="simple"
      title={
        <div className="gray normal">
          Lame <span className="black">{slice.barcode}</span>
        </div>
      }
      subTitle={
        <div className="c1 gap10">
          {slice.uploads && slice.uploads.length > 0 && (
            <div className="gray">{slice.uploads?.length} fichiers</div>
          )}
        </div>
      }
      onClick={async () => {
        await openAnapathSampleSliceForm({
          sampleSlice: slice,
          onSave: async (sampleSlice) => {
            onChange(sampleSlice);
          },
        });
      }}
      onDelete={async () => {
        openDeleteDialog(async () => {
          await apiFetch("sampleSlices", "deleteOne", {
            id: slice.id!,
          });
          onChange(slice);
        });
      }}
    ></Card>
  );
}

export default SliceCard;
